const OAUTH_ACCESS_TOKEN_KEY = 'oauth_access_token';
const OAUTH_REFRESH_TOKEN_KEY = 'oauth_refresh_token';
const OAUTH_ACCESS_TOKEN_EXPIRES_KEY = 'oauth_access_token_expires';

export const getToken = () => {
  return window.localStorage.getItem(OAUTH_ACCESS_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(OAUTH_ACCESS_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(OAUTH_ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(OAUTH_REFRESH_TOKEN_KEY);
  window.localStorage.removeItem(OAUTH_ACCESS_TOKEN_EXPIRES_KEY);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(OAUTH_REFRESH_TOKEN_KEY);
};

export const saveRefreshToken = token => {
  window.localStorage.setItem(OAUTH_REFRESH_TOKEN_KEY, token);
};

export const getTokenExpires = () => {
  return window.localStorage.getItem(OAUTH_ACCESS_TOKEN_EXPIRES_KEY);
};

export const saveTokenExpires = expires => {
  window.localStorage.setItem(OAUTH_ACCESS_TOKEN_EXPIRES_KEY, expires);
};

export default { getToken, saveToken, destroyToken, getRefreshToken, saveRefreshToken,
  getTokenExpires, saveTokenExpires };
